export default __webpack_public_path__ + "static/media/US-UK-India.65314db2.svg";